// Composed skeleton that mimics a glass card: title line + N body lines,
// inside a rounded rectangle the same dimensions as a real card. Use in
// place of an ActivityIndicator while a card-shaped section is loading.
//
// Example:
//   {cycle.isLoading ? <CardSkeleton lines={3} /> : <ActiveCycleCard ... />}
import { View } from "react-native";
import { MoonSkeleton } from "./MoonSkeleton";
import { spacing, radii } from "../theme/tokens";

type Props = {
  /** Body lines to render under the title. Default 2. */
  lines?: number;
  /** Show a placeholder for a small status pill / right-side detail. */
  showTrailing?: boolean;
};

export function CardSkeleton({ lines = 2, showTrailing }: Props) {
  return (
    <View
      style={{
        backgroundColor: "rgba(255, 255, 255, 0.3)",
        borderRadius: radii.lg,
        padding: spacing.lg,
        gap: spacing.sm + 2,
      }}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          gap: spacing.sm,
        }}
      >
        <MoonSkeleton width="55%" height={18} />
        {showTrailing && <MoonSkeleton width={48} height={14} radius={7} />}
      </View>
      {Array.from({ length: lines }).map((_, i) => (
        <MoonSkeleton
          key={i}
          width={i === lines - 1 ? "70%" : "100%"}
          height={12}
        />
      ))}
    </View>
  );
}
